import React, { Component } from 'react';
import ClassList from 'class-list';

import Loader from './Loader';

class Loading extends Component {
  componentDidMount() {
    const cl = ClassList(document.body);
    cl.add('overflow-hidden');
  }

  componentWillUnmount() {
    const cl = ClassList(document.body);
    cl.remove('overflow-hidden');
  }

  render() {
    return (
      <div className="z-60 w-screen h-screen-real fixed inset-y-0 inset-x-0 flex justify-center items-center">
        <div className="bg-gray-200 opacity-50 absolute inset-y-0 inset-x-0 w-screen h-screen-real"></div>
        <Loader />
      </div>
    );
  }
}

export default Loading;